export default "__VITE_ASSET__BmDpQnNB__"